module.exports = __webpack_public_path__ + "static/img/m1.dbb0b7d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/iot/m1.png
// module id = BYui
// module chunks = 0